export class EnumApiLegal {
    constructor() {
        /**
         * @dec 保存用户确认协议日志
         */
        this.legal_portal_protocol_save = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/public/protocol/log/save',
            method: 'post',
        };
        /**
         * @dec 协议确认列表
         */
        this.legal_portal_protocol_userLog_findForPage = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/protocol/log/findForPage',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 查询协议列表
         */
        this.legal_portal_protocol_list = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/public/protocol/list',
            method: 'get',
        };
        /**
         * @dec 合作伙伴网络注册协议/隐私协议等
         */
        this.partner_network_registration_agreement = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/public/protocol/list',
            method: 'get',
            loading: true,
        };
        /**
         * @dec 用户登录记录列表搜索项：登录场景
         */
        this.login_record_sence = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/protocol/scene/list',
            method: 'get',
        };
        /**
         * @dec 用户登录记录列表搜索项：条款名称
         */
        this.login_record_agreement = {
            url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/protocol/search/list',
            method: 'get',
        };
    }
}
